module.exports = __webpack_public_path__ + "media/images/application/default/default-societe-f09a97bae3e0cde698f2b7e8917f20f6.jpg";